import * as Sentry from '@sentry/react';

import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';
import { Button } from '@/ui/components/arandu/button';
import { Icon } from '@/ui/components/icon';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();

  Sentry.captureException(error);

  return (
    <section className='grid place-content-center text-center h-full'>
      <Icon icon='x-circle-icon' className='w-xl h-xl text-base-danger-600 mx-auto' />
      <h1 className='font-bold text-ctx-content-title text-md'>{t('page.error')}</h1>
      <p className='text-ctx-content-title'>{t('page.error.description')}</p>
      <Button onClick={() => window.location.reload()} className='mx-auto mt-mini' hierarchy='tertiary' size='sm'>
        {t('reload-page')}
      </Button>
    </section>
  );
};
